export const goToTop = () => {
  window.scrollTo({
    top: 0,
    // behavior: 'smooth',
  })
}
